import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import { DesignTokens, pancakeTheme } from '@klarna/bubble-ui';
import Combobox from '@bubble-contrib/molecule-combobox';
import { withTooltip } from 'moet-core';

let onSearchDebounced;

const customTokens = {
  'field/background-color': DesignTokens.colorTokenFromNestedArguments(
    {
      focused: {
        default: (tokenResolver, args) => tokenResolver('colors/backgrounds/transparent', args),
      },
      default: {
        error: (tokenResolver, args) => tokenResolver('colors/backgrounds/error-inline', args),
        warning: (tokenResolver, args) => tokenResolver('colors/backgrounds/warning-inline', args),
        autofill: (tokenResolver, args) => tokenResolver('colors/backgrounds/accent-inline', args),
        default: (tokenResolver, args) => tokenResolver('colors/backgrounds/transparent', args),
      },
    },
    ['interactiveState', 'successState'],
  ),
};

const customTokensComplete = {
  ...pancakeTheme(false),
  ...customTokens,
};

const AutoSuggest = ({
  allowCustomValue = true,
  onChange = () => {},
  onSearch,
  onSelect = () => {},
  options = [],
  searchDebounce = 500,
  value: propsValue,
  ...otherProps
}) => {
  const selectedOption = options.find(o => o.value === propsValue);
  const customValue =
    propsValue && allowCustomValue ? { value: propsValue, label: propsValue } : undefined;

  const [value, setValue] = useState(selectedOption || customValue);

  useEffect(() => {
    onSearchDebounced =
      onSearch && typeof onSearch === 'function' ? debounce(onSearch, searchDebounce) : undefined;
  }, []);

  const onChangeHandler = ({ item, customValue }) => {
    setValue(item);
    onChange(item.value);
    if (!customValue) {
      onSelect(item.value);
    }
  };

  const onSearchHandler = val => {
    if (onSearchDebounced) {
      onChange(val);
      onSearchDebounced(val);
    }
  };

  return (
    <DesignTokens.DesignContextProvider tokens={customTokensComplete}>
      <Combobox
        onChange={onChangeHandler}
        onSearch={onSearchHandler}
        value={value}
        options={options}
        allowCustomValue={allowCustomValue}
        {...otherProps}
      />
    </DesignTokens.DesignContextProvider>
  );
};

AutoSuggest.propTypes = {
  allowCustomValue: PropTypes.bool,
  options: PropTypes.array,
  searchDebounce: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
};

export default withTooltip(AutoSuggest);
